<div class="body-container-wrapper">
    <section class="inner-page-banner light-banner support-banner banner">

        <div class="container">
            <div class="banner-caption">
                <h1>Invest in Your Future</h1>
                <h6>At BajajCapital, we immensely value our people. This is because we believe that our services will be
                    only as good as those who deliver them.</h6> <br>
                <a target="_blank" class="btn btn-primary">View Openings</a>
            </div>

        </div>
    </section>
    <section class="graduate-section">
        <div class="container">
            <div class="details">
                <div class="box">
                    <p>Are you a graduate?</p>
                    <p>Do you want to build a career with BajajCapital?</p>
                </div>
                <div>
                    <img src="../../../assets/images/career/next.png" class="img-fluid next-arrow" alt="arrow">
                </div>
                <div class="box">
                    <p>Your route to becoming a Wealth Manager by Joining 6 Months Integrated Diploma in Wealth
                        Management (IDWM) from ICOFP</p>
                </div>
                <div>
                    <img src="../../../assets/images/career/next.png" class="img-fluid next-arrow" alt="arrow">
                </div>
                <div class="box linked">
                    <a href="https://www.icofp.org/integrated-diploma-in-wealth-management" target="_blank">Know more
                        <br>About the Program</a>
                </div>
            </div>
        </div>
    </section>
    <section class="bgwhite intro-section">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10 col-xl-9 text-center">
                    <h2 class="section-title card-title">What Makes Us Special<span class="wow"></span></h2>
                    <h6>We are in the business of guiding our investors about to put their hard-earned money and helping
                        them achieve their financial goals through wise decisions. Trust and goodwill form the
                        fundamental basis of our relationships with people.</h6>
                    <a [routerLink]="['/about-us']" class="read-more">Get to know us better <i
                            class="fas fa-chevron-right"></i></a>
                </div>
                <div></div>

                <div class="col-12 text-center">
                    <h6 class="fs115">Already picturing yourself here? Join us</h6>
                    <a target="_blank" class="read-more btn mt-5">Explore open roles</a>
                </div>
            </div>
        </div>
    </section>
    <section class="advantage-section">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2 class="card-title section-title">Working at BajajCapital Is<br>a Rewarding Experience <span
                            class="wow"></span></h2>
                </div>
                <ng-container>
                    <div class="col-lg-6 col-md-6 mb-3">
                        <div class="advantage-module">
                            <div class="module-icon">
                                <img src="../../assets/images/career/career-icon-01.png" width="42">
                            </div>
                            <div class="module-content">
                                <h6>OPPORTUNITY TO UPSKILL</h6>
                                <p class="listing"> We lay a lot of emphasis on continuing education. Every team member
                                    is encouraged to undergo professional training. The company even offers incentives
                                    to those pursuing professional programmes and consequently building on their skill
                                    set.</p>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container>
                    <div class="col-lg-6 col-md-6">
                        <div class="advantage-module">
                            <div class="module-icon">
                                <img src="../../assets/images/career/career-icon-02.png" width="42">
                            </div>
                            <div class="module-content">
                                <h6>
                                    YOUR HEALTH MATTER</h6>
                                <p class="listing"> BajajCapital encourages a holistic way of life. All our offices are
                                    no-smoking areas. Efforts are also made to inculcate healthy habits among all. There
                                    are no night shifts. We also organise mindfulness sessions to improve the health and
                                    well-being of our team members.</p>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container>
                    <div class="col-lg-6 col-md-6 mb-3">
                        <div class="advantage-module">
                            <div class="module-icon">
                                <img src="../../assets/images/career/career-icon-03.png" width="42">
                            </div>
                            <div class="module-content">
                                <h6>
                                    OPEN-DOOR POLICY</h6>
                                <p class="listing">The entire top management and the leaders at BajajCapital are always
                                    accessible. They are ever-willing to help and hear you out whenever you need them.
                                    There is a supportive, healthy work culture where everyone is treated equally.</p>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container>
                    <div class="col-lg-6 col-md-6">
                        <div class="advantage-module">
                            <div class="module-icon">
                                <img src="../../assets/images/career/career-icon-04.png" width="42">
                            </div>
                            <div class="module-content">
                                <h6>
                                    COMPENSATION & RECOGNITION</h6>
                                <p class="listing">A fair chance to excel, with due recognition to all outperformers, is
                                    our obligation. BajajCapital offers a compensation package that's one of the best in
                                    the industry. We believe and ask our team members to write their own cheques.</p>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </section>

    <section class="award-section bgwhite ">
        <div class="container">
            <div class="row d-md-flex d-none">
                <ng-container>
                    <div class="col-12 col-md-4 ">
                        <div class="box">
                            <img src="../../assets/images/career/CNBC-17-18.png" class="img-fluid" alt="">
                            <h6><span class="quote"><i class="fas fa-trophy"></i></span><strong>National Financial
                                    Advisor-Retail</strong>
                            </h6>
                            <p>Best Performing National Financial Advisor - Retail" at the CNBC TV 18 Advisor Awards
                                2017 -2018</p>
                        </div>
                    </div>
                </ng-container>
                <ng-container>
                    <div class="col-12 col-md-4 ">
                        <div class="box">
                            <img src="../../assets/images/career/great-place-work-bajaj-capital.png" class="img-fluid"
                                alt="">
                            <h6><span class="quote"><i class="fas fa-trophy"></i></span><strong>Great Place to Work
                                    Certification</strong>
                            </h6>
                            <p>Adjudged "Best Place to Work - India" in 2009, 2011, 2012 ,2019 and 2020 by Great Place
                                to Work Institute</p>
                        </div>
                    </div>
                </ng-container>
                <ng-container>
                    <div class="col-12 col-md-4 ">
                        <div class="box">
                            <img src="../../assets/images/career/ET-BFSI.png" class="img-fluid" alt="">
                            <h6><span class="quote"><i class="fas fa-trophy"></i></span><strong>Best BFSI Brand -
                                    Broking Category</strong>
                            </h6>
                            <p>The Economic Times recognises BajajCapital for being a symbol of excellence in NBFC
                                category</p>
                        </div>
                    </div>
                </ng-container>
            </div>


            <div class="row d-md-none">
                <div class="col-12">
                    <div id="awardCarousel" class="tab-dots carousel slide" data-ride="carousel" data-interval="5000">

                        <ol class="carousel-indicators">
                            <ng-container>
                                <li data-target="#awardCarousel"></li>
                            </ng-container>

                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>